import { GoldRoomInfo } from "./goldentrance_matching_view";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import ItemInfo from './itemInfo';
import AppData from '../../../public/const/app_data';
import ModelData from "../../../public/model_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class GoldRoomMatchingItem extends cc.Component {
    @property(ItemInfo)
    itemInfo: ItemInfo[] = [];
    @property(cc.Font)
    labelFont: cc.Font[] = [];
    @property(cc.Color)
    labelColor: cc.Color[] = [];
    @property(cc.Label)
    labelLevelLock: cc.Label = null

    // @property(cc.Sprite)
    // icon1: cc.Sprite = null;
    // @property(cc.Sprite)
    // icon2: cc.Sprite = null;
    @property(SpriteFrameHolder)
    iconSprFrameHolder: SpriteFrameHolder = null;
    @property(cc.Node)
    recommendEffect: cc.Node = null;
    @property(cc.Node)
    infoNode: cc.Node = null;
    @property(cc.Node)
    infoNode2: cc.Node = null;
    @property(cc.Sprite)
    sprite: cc.Sprite = null;
    // @property(cc.Node)
    // dragonBones: cc.Node[] = [];
    // @property(cc.Node)
    // dragonBonesMango: cc.Node[] = [];
    
    public info: GoldRoomInfo = null
    isMangoSession: boolean = false;
    setData(data: GoldRoomInfo, index: number, isRecommend: boolean) {
        cc.log("setData,AppData.gameName:", AppData.gameName);
        this.info = data;
        this.resetItem();
        //cc.log("屏蔽掉芒果场");

        this.isMangoSession = false;
        this.fillicon(data);
        this.updateInfo(AppData.gameName, data);
        if (data.openLevel && ModelData.instance.roleData.userLevel < data.openLevel) {
            this.labelLevelLock.node.parent.active = true
            this.labelLevelLock.string = "Lv" + data.openLevel
        } else {
            this.labelLevelLock.node.parent.active = false
        }
        //cc.log("this.recommendEffect.active:",this.recommendEffect.active);
        this.recommendEffect.active = isRecommend;
        this.sprite.node.getComponent(cc.Animation).enabled = isRecommend
    }
    setDZPKData(data: GoldRoomInfo, index: number, xindex: number, isSelect: boolean) {
        //cc.log("setDZPKData:", xindex, AppData.gameName);
        this.info = data;
        this.resetItem();
        //cc.log("屏蔽掉芒果场");
        this.isMangoSession = false;
       
        this.fillicon(data);
        cc.log("data,xindex", data, xindex);
        this.updateDZPKInfo(data, xindex);
        this.recommendEffect.active = isSelect;
        this.sprite.node.getComponent(cc.Animation).enabled = isSelect
    }
    init() {
        this.info = null;
        this.node.active = false;
    }
    fillicon(data: GoldRoomInfo) {
        var goldType = Number(data.goldData.goldType);
        var key = this.turnRoomtype(goldType);
        key =  Math.floor((key - 1) / 2)
        data.index = key
        data.labelColor = this.labelColor
        data.labelFont = this.labelFont
        this.sprite.spriteFrame = this.iconSprFrameHolder.getListSpriteFrameByKey(AppData.gameName, key.toString());
    }

    turnRoomtype(goldType: number) {
        var index = 0;
        if (goldType == 10) {
            index = 0;
        }
        else {
            index = goldType;
        }
        return index;
    }

    updateInfo(gameID: string, data: any) {
        let self = this;
        //cc.log("updateInfo,gameID:", gameID);
        //cc.log("gameID:",gameID);
        switch (gameID) {
            case "TM_BPZD":
            case "TM_BP":
                this.updateBP(data);
                break;
            case "TM_HJK":
                this.updateBlackJack(data);
                break;
            case "TM_QZNN":
                this.updateBull(data);
                break;
            case "TM_JD":
                this.updateninePoint(data);
                break;
            case "TM_JK":
                this.updateK9(data);
                break;
            case "TM_Q2":
                this.updateQ2(data);
                break;
            case "TM_SLOT":
                this.updateSlot(data);
                break;

        }
    }
    updateDZPKInfo(data: any, xindex: number) {
        this.updateDZPk(data, xindex);
    }
    updateBull(data: any) {
        let self = this;
        // cc.log("设置牛牛的：",self.nodeList[0]);
        self.itemInfo[0].node.active = true;
        // cc.log("设置牛牛的显示：",self.nodeList[0]);
        self.itemInfo[0].updateBullBullItem(data)

    }

    updateSlot(data: any) {

        this.itemInfo[7].updateSlot(data)
    }

    updateBP(data: any) {
        let self = this;
        this.itemInfo[3].node.active = true;
        self.itemInfo[3].updateBP(data);
    }
    updateninePoint(data: any) {
        let self = this;
        this.itemInfo[1].node.active = true;
        self.itemInfo[1].updateNinePointItem(data);
    }
    updateBlackJack(data: any) {
        let self = this;
        this.itemInfo[2].node.active = true;
        self.itemInfo[2].updateBlackJack(data);
    }
    updateK9(data: any) {
        this.itemInfo[5].node.active = true;
        this.itemInfo[5].updateK9(data);
    }

    updateDZPk(data: any, xindex: number) {
        let self = this;
        for (var i = 0; i < this.itemInfo.length; i++) {
            self.itemInfo[i].node.active = false;
        }
        this.itemInfo[4].node.active = true;
        self.itemInfo[4].updateDZPKItem(data, xindex);
        cc.log("changeItem:", xindex);
        this.changeItem(xindex);
    }

    updateQ2(data: any) {
        this.itemInfo[6].node.active = true;
        this.itemInfo[6].updateQ2(data);
    }

    resetItem() {
        // this.dragonBones.forEach((node) => {
        //     node.active = false;
        // });

        // this.dragonBonesMango.forEach((node) => {
        //     node.active = false;
        // });

        for (var i = 0; i < this.itemInfo.length; i++) {
            this.itemInfo[i].node.active = false;
        }
    }
    changeItem(index: number) {
        cc.log("changeItem(index:number):", index);
        if (index == 0) {
            this.infoNode.active = false;
            this.infoNode2.active = true;
        } else if (index == 1) {
            this.infoNode.active = true;
            this.infoNode2.active = false;
        }

    }
    refreshRecommend(tf: boolean) {
        this.recommendEffect.active = tf;
        this.sprite.node.getComponent(cc.Animation).enabled = tf
    }
}
